import axios from "axios";

// 🔧 Fonction dédiée à la mise à jour d’un contact
export const createContactRowUpdate = (groupeId, setContacts) => {
  return async (newRow, oldRow) => {
    const mergedRow = { ...oldRow, ...newRow };

    // ✅ Validation du téléphone (optionnel mais 10 chiffres si présent)
    const tel = mergedRow.telephone?.replace(/\D/g, "");
    if (tel && (tel.length < 9 || tel.length > 15)) {
      throw new Error("Le numéro de téléphone doit contenir entre 9 et 15 chiffres.");
    }

    // ✅ Validation de l’email (optionnel mais bien formé si présent)
    const email = mergedRow.mail?.trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      throw new Error("L’adresse email est invalide.");
    }

    // 🔄 Mise à jour locale
    setContacts(prev =>
      prev.map(row =>
        row._id === mergedRow._id ? mergedRow : row
      )
    );

    // 📡 Envoi vers l’API
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/contacts/${mergedRow._id}`,
        { ...mergedRow, groupe: groupeId }
      );
      return { ...mergedRow, ...res.data };
    } catch (err) {
      console.error("Erreur mise à jour contact :", err);
      return oldRow;
    }
  };
};
